/**
 * Mentions légales — texte JURIDIQUE VALIDÉ. Ne pas reformuler.
 */
const MENTIONS_LEGALES_FR = String.raw`
# Mentions légales

**archer.law**
Dernière mise à jour : {{DATE_MISE_EN_LIGNE}}

*Le présent document est disponible en français, néerlandais et anglais. En cas de divergence entre les versions linguistiques, la version française prévaut.*

## Éditeur du site

Le site archer.law est édité par :

**RND CONCIERGE SERVICES - FZCO**
Société de zone franche (Freezone Company) de droit émirien
Licence commerciale n° 63620 · Dubai Integrated Economic Zones Authority (IFZA)
Siège social : DSO-IFZA, IFZA Properties, Dubai Silicon Oasis, Dubaï, Émirats arabes unis

**Responsable de la publication** : Romain Debecq, manager

**Contact et données personnelles** : bonjour@archer.law

## Hébergement

L'application et les données sont hébergées par :

**Railway Corporation**
548 Market St, San Francisco, CA 94104, États-Unis
railway.com

## Nature du service

Archer est une plateforme technologique d'information et d'assistance juridique. **Archer n'est pas un cabinet d'avocats** et n'est pas inscrit à un barreau ; **Archer n'est pas une compagnie d'assurance**. Les contenus générés par le Service constituent de l'information juridique et ne remplacent pas la consultation d'un avocat. Les avocats accessibles via la marketplace sont des professionnels indépendants, inscrits à un barreau belge, qui contractent directement avec le client.

## Propriété intellectuelle

L'ensemble des éléments du site (structure, textes, graphismes, logos, la mascotte Archer, logiciels) est protégé par le droit d'auteur et le droit des marques. Toute reproduction ou représentation, totale ou partielle, sans autorisation écrite préalable est interdite, à l'exception des usages strictement privés et des livrables générés pour le client dans le cadre du Service.

## Signalement

Pour signaler un contenu ou un usage illicite du Service : bonjour@archer.law. Nous traitons les signalements avec diligence.

## Litiges et médiation

Le site et les services sont régis par les Conditions Générales, soumises au droit belge. Le consommateur peut recourir au Service de Médiation pour le Consommateur (mediationconsommateur.be, Boulevard du Roi Albert II 8 bte 1, 1000 Bruxelles) et à la plateforme européenne de règlement en ligne des litiges : ec.europa.eu/consumers/odr.
`;

export default MENTIONS_LEGALES_FR;
